import React, { useEffect } from 'react';
import { Roles } from '../../../../../common/src/enums/Roles';
import { CollapsiblePanel, EditPanel, EditPanelCell, EditPanelCellLabel, EditPanelRow, PanelBody, Tray } from '../../../components/elements';
import { ISurveyTemplateUnitData } from '../../../components/Surveys/ISurveyTemplateUnitData';
import { useUserHasRole } from '../../../components/utils/authorization/useUserHasRole';
import { openApiFetchPost } from '../../../store/openApiFetch';
import { useOpenApiFetch } from '../../../store/useOpenApiFetch';

export function SurveyEditAoBasisgegevensUnitAll(
    props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & ISurveyTemplateUnitData,
) {
    const { userHasRole } = useUserHasRole();
    const isAdmin = userHasRole([Roles.Administrator]);
    const [jsonData, setJsonData] = React.useState<string | undefined>();

    const { data } = useOpenApiFetch(
        '/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/amsterdamOverspanningen/basisgegevens',
        'get',
        { surveyId: props.surveyId, unitId: props.unitId },
        [props.surveyId, props.unitId],
    );

    useEffect(() => {
        setJsonData(JSON.stringify(data, null, 2));
    }, [data]);

    async function save() {
        if (!jsonData) {
            alert('Invalid JSON');
            return;
        }
        try {
            JSON.parse(jsonData);
            await openApiFetchPost(
                '/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/amsterdamOverspanningen/basisgegevens',
                { surveyId: props.surveyId, unitId: props.unitId },
                { jsonData },
            );
        } catch (_e) {
            alert('Invalid JSON');
        }
    }

    if (data === undefined) {
        return null;
    }

    return (
        <Tray>
            <EditPanel bottomMargin={true} noPadding={true}>
                <CollapsiblePanel heading={{ dark: true, text: `${props.unitName} details` }}>
                    <PanelBody isForm={true}>
                        <EditPanelRow>
                            <EditPanelCellLabel rowCount={2} text="All values"></EditPanelCellLabel>
                            <EditPanelCell rowCount={10}>
                                {isAdmin ? (
                                    <>
                                        <textarea value={jsonData} onChange={(e) => setJsonData(e.target.value)} cols={100} rows={20} />
                                        <button onClick={save}>Save</button>
                                    </>
                                ) : (
                                    <>{JSON.stringify(data)}</>
                                )}
                            </EditPanelCell>
                        </EditPanelRow>
                    </PanelBody>
                </CollapsiblePanel>
            </EditPanel>
        </Tray>
    );
}
